import { FieldTitle } from '../shadcn/field';

export const Info = ({ children }: React.PropsWithChildren) => (
  <FieldTitle className="block text-body-large font-normal text-content-light">{children}</FieldTitle>
);
